import type { ContentItem } from '../contentLibrary'

export const QING_ARTICLES: ContentItem[] = [
  {
    id: 'classic-dizigui',
    category: 'classic',
    dynasty: 'qing',
    title: '弟子規',
    source: '蒙學經典',
    description: '短句結構清楚，適合行列抄寫。',
    content: '弟子規，聖人訓。首孝弟，次謹信。泛愛眾，而親仁。有餘力，則學文。父母呼，應勿緩。父母命，行勿懶。父母教，須敬聽。父母責，須順承。冬則溫，夏則凊。晨則省，昏則定。出必告，反必面。居有常，業無變。事雖小，勿擅為。苟擅為，子道虧。物雖小，勿私藏。苟私藏，親心傷。親所好，力為具。親所惡，謹為去。身有傷，貽親憂。德有傷，貽親羞。親愛我，孝何難。親憎我，孝方賢。親有過，諫使更。怡吾色，柔吾聲。諫不入，悅復諫。號泣隨，撻無怨。親有疾，藥先嘗。晝夜侍，不離床。喪三年，常悲咽。居處變，酒肉絕。喪盡禮，祭盡誠。事死者，如事生。',
  },

  {
    id: 'poem-qing-changxiang',
    category: 'poem',
    dynasty: 'qing',
    title: '長相思·山一程',
    source: '納蘭性德',
    description: '納蘭性德隨康熙出巡途中所作，思鄉之情真摯動人。',
    content: '山一程，水一程，身向榆關那畔行，夜深千帳燈。風一更，雪一更，聒碎鄉心夢不成，故園無此聲。',
  },

  {
    id: 'poem-qing-huanxisha',
    category: 'poem',
    dynasty: 'qing',
    title: '浣溪沙·誰念西風獨自涼',
    source: '納蘭性德',
    description: '納蘭性德悼亡詞，西風蕭瑟，追憶亡妻。',
    content: '誰念西風獨自涼，蕭蕭黃葉閉疏窗，沉思往事立殘陽。被酒莫驚春睡重，賭書消得潑茶香，當時只道是尋常。',
  },

  {
    id: 'poem-qing-mulan',
    category: 'poem',
    dynasty: 'qing',
    title: '木蘭詞·擬古決絕詞',
    source: '納蘭性德',
    description: '納蘭性德以女子口吻寫決絕，「人生若只如初見」傳誦千古。',
    content: '人生若只如初見，何事秋風悲畫扇。等閒變卻故人心，卻道故心人易變。驪山語罷清宵半，淚雨霖鈴終不怨。何如薄倖錦衣郎，比翼連枝當日願。',
  },

  {
    id: 'poem-qing-dielianhua',
    category: 'poem',
    dynasty: 'qing',
    title: '蝶戀花·出塞',
    source: '納蘭性德',
    description: '納蘭性德出塞懷古，感嘆古今興亡。',
    content: '今古河山無定據。畫角聲中，牧馬頻來去。滿目荒涼誰可語？西風吹老丹楓樹。從前幽怨應無數。鐵馬金戈，青冢黃昏路。一往情深深幾許？深山夕照深秋雨。',
  },

  {
    id: 'poem-qing-zhushi',
    category: 'poem',
    dynasty: 'qing',
    title: '竹石',
    source: '鄭燮',
    description: '鄭板橋題畫詩，借竹石表現剛毅不屈的品格。',
    content: '咬定青山不放鬆，立根原在破岩中。千磨萬擊還堅勁，任爾東西南北風。',
  },

  {
    id: 'poem-qing-suojian',
    category: 'poem',
    dynasty: 'qing',
    title: '所見',
    source: '袁枚',
    description: '袁枚寫牧童捕蟬的田園小景，生動有趣。',
    content: '牧童騎黃牛，歌聲振林樾。意欲捕鳴蟬，忽然閉口立。',
  },

  {
    id: 'poem-qing-tai',
    category: 'poem',
    dynasty: 'qing',
    title: '苔',
    source: '袁枚',
    description: '苔花雖小，亦學牡丹盛開，激勵無數平凡之人。',
    content: '白日不到處，青春恰自來。苔花如米小，也學牡丹開。',
  },

  {
    id: 'poem-qing-zanghua',
    category: 'poem',
    dynasty: 'qing',
    title: '葬花吟（全文）',
    source: '曹雪芹',
    description: '林黛玉感花傷己之作，淒美絕倫，是《紅樓夢》詩詞巔峰。',
    content: '花謝花飛花滿天，紅消香斷有誰憐？遊絲軟繫飄春榭，落絮輕沾撲繡簾。閨中女兒惜春暮，愁緒滿懷無釋處。手把花鋤出繡簾，忍踏落花來復去。柳絲榆莢自芳菲，不管桃飄與李飛。桃李明年能再發，明年閨中知有誰？三月香巢已壘成，梁間燕子太無情！明年花發雖可啄，卻不道人去梁空巢也傾。一年三百六十日，風刀霜劍嚴相逼。明媚鮮妍能幾時，一朝漂泊難尋覓。花開易見落難尋，階前愁殺葬花人。獨把花鋤淚暗灑，灑上空枝見血痕。杜鵑無語正黃昏，荷鋤歸去掩重門。青燈照壁人初睡，冷雨敲窗被未溫。怪倌底事半消磨，半為憐春半惱春。憐春忽至惱忽去，無聲無息榮枯因。昨宵庭外悲歌發，知是花魂與鳥魂？花魂鳥魂總難留，鳥自無言花自羞。願奴脅下生雙翼，隨花飛到天盡頭。天盡頭，何處有香丘？未若錦囊收豔骨，一抔淨土掩風流。質本潔來還潔去，強於污淖陷渠溝。爾今死去儂收葬，未卜儂身何日喪？儂今葬花人笑痴，他年葬儂知是誰？試看春殘花漸落，便是紅顏老死時。一朝春盡紅顏老，花落人亡兩不知！',
  },

  {
    id: 'poem-qing-haoliaoge',
    category: 'poem',
    dynasty: 'qing',
    title: '紅樓夢·好了歌',
    source: '曹雪芹',
    description: '跛足道人所唱，點破世間功名富貴的虛幻。',
    content: '世人都曉神仙好，惟有功名忘不了。古今將相在何方？荒塚一堆草沒了。世人都曉神仙好，只有金銀忘不了。終朝只恨聚無多，及到多時眼閉了。世人都曉神仙好，只有嬌妻忘不了。君生日日說恩情，君死又隨人去了。世人都曉神仙好，只有兒孫忘不了。痴心父母古來多，孝順兒孫誰見了。',
  },

  {
    id: 'poem-qing-jihai',
    category: 'poem',
    dynasty: 'qing',
    title: '己亥雜詩·浩蕩離愁白日斜',
    source: '龔自珍',
    description: '龔自珍辭官南歸途中所作，憂國憂民。',
    content: '浩蕩離愁白日斜，吟鞭東指即天涯。落紅不是無情物，化作春泥更護花。',
  },

  {
    id: 'poem-qing-jihai2',
    category: 'poem',
    dynasty: 'qing',
    title: '己亥雜詩·九州生氣恃風雷',
    source: '龔自珍',
    description: '龔自珍呼籲變革，期盼打破沉悶、廣納人才。',
    content: '九州生氣恃風雷，萬馬齊喑究可哀。我勸天公重抖擻，不拘一格降人才。',
  },

  {
    id: 'poem-qing-linzexu',
    category: 'poem',
    dynasty: 'qing',
    title: '赴戍登程口占示家人',
    source: '林則徐',
    description: '林則徐被貶伊犁，與家人告別，以國家為重。',
    content: '力微任重久神疲，再竭衰庸定不支。苟利國家生死以，豈因禍福避趨之。謫居正是君恩厚，養拙剛於戍卒宜。戲與山妻談故事，試吟斷送老頭皮。',
  },

  {
    id: 'poem-qing-lunshi',
    category: 'poem',
    dynasty: 'qing',
    title: '論詩',
    source: '趙翼',
    description: '趙翼論詩主張創新，各領風騷數百年。',
    content: '李杜詩篇萬口傳，至今已覺不新鮮。江山代有才人出，各領風騷數百年。',
  },

  {
    id: 'classic-qing-fusheng',
    category: 'classic',
    dynasty: 'qing',
    title: '浮生六記·兒時記趣（全文）',
    source: '沈復',
    description: '沈復自傳散文《浮生六記》之〈閒情記趣〉，回憶童年觀察蚊蟲、花草之趣。',
    content: '余憶童稚時，能張目對日，明察秋毫。見藐小微物，必細察其紋理，故時有物外之趣。夏蚊成雷，私擬作群鶴舞空，心之所向，則或千或百，果然鶴也。昂首觀之，項為之強。又留蚊於素帳中，徐噴以煙，使其沖煙飛鳴，作青雲白鶴觀，果如鶴唳雲端，為之怡然稱快。又常於土牆凹凸處、花台小草叢雜處，蹲其身，使與台齊。定神細視，以叢草為林，以蟲蟻為獸，以土礫凸者為丘，凹者為壑，神遊其中，怡然自得。一日，見二蟲鬥草間，觀之，興正濃，忽有龐然大物，拔山倒樹而來，蓋一癩蝦蟆也。舌一吐而二蟲盡為所吞。余年幼，方出神，不覺呀然驚恐。神定，捉蝦蟆，鞭數十，驅之別院。',
  },

  {
    id: 'poem-qing-yuzhong',
    category: 'poem',
    dynasty: 'qing',
    title: '獄中題壁',
    source: '譚嗣同',
    description: '譚嗣同戊戌變法失敗後從容就義，氣壯山河。',
    content: '望門投止思張儉，忍死須臾待杜根。我自橫刀向天笑，去留肝膽兩崑崙。',
  },

  {
    id: 'poem-qing-duijiu',
    category: 'poem',
    dynasty: 'qing',
    title: '對酒',
    source: '秋瑾',
    description: '秋瑾革命壯志，巾幗不讓鬚眉。',
    content: '不惜千金買寶刀，貂裘換酒也堪豪。一腔熱血勤珍重，灑去猶能化碧濤。',
  },

  {
    id: 'poem-qing-jinze',
    category: 'classic',
    dynasty: 'qing',
    title: '人間詞話·三境界（全文）',
    source: '王國維',
    description: '王國維論詞三境界，影響深遠。',
    content: '古今之成大事業、大學問者，必經過三種之境界。「昨夜西風凋碧樹，獨上高樓，望盡天涯路。」此第一境也。「衣帶漸寬終不悔，為伊消得人憔悴。」此第二境也。「眾裡尋他千百度，驀然回首，那人卻在，燈火闌珊處。」此第三境也。此等語皆非大詞人不能道。然遽以此意解釋古人，恐為晏、歐、辛諸公所不許也。',
  },

  {
    id: 'classic-lianchi',
    category: 'classic',
    dynasty: 'qing',
    title: '廉恥（全文）',
    source: '顧炎武',
    description: '顧炎武論廉恥為立國之大節，針砭時弊。',
    content: '五代史馮道傳論曰：「禮義廉恥，國之四維。四維不張，國乃滅亡。」禮義，治人之大法；廉恥，立人之大節。蓋不廉則無所不取，不恥則無所不為。人而無恥，是主大恥；人而能恥，是為大賢。自古國家之興衰，莫不繫於士大夫之有恥與無恥。士大夫無恥，是為國恥。吾觀今之世，士大夫多趨炎附勢，諂媚權貴，不以為恥，反以為榮。此風一開，則廉恥掃地，綱紀蕩然。故知恥之於人，大矣！孟子曰：「人不可以無恥，無恥之恥，無恥矣。」又曰：「恥之於人大矣，為機變之巧者，無所用恥焉。」士君子立身處世，當以廉恥為本。若能深知廉恥之意，則自能潔身自好，不為利誘，不為威屈，庶幾可為國家之棟梁，不負所學也。',
  },

  {
    id: 'classic-dengtaishanji',
    category: 'classic',
    dynasty: 'qing',
    title: '登泰山記',
    source: '姚鼐',
    description: '姚鼐記冬日登泰山觀日出的壯麗景色。',
    content: '泰山之陽，汶水西流；其陰，濟水東流。陽谷皆入汶，陰谷皆入濟。當其南北分處，古長城也。最高日觀峰，在長城南十五里。余以乾隆三十九年十二月，自京師乘風雪，歷齊河、長清，穿泰山西北谷，越長城之限，至於泰安。是月丁未，與知府朱夢蓮沙河登。循東谷入，道皆砌石為磴，凡七千有餘。泰山多石，少土。石蒼黑色，多平方，少圓。及既上，蒼山負雪，明燭天南。望晚日照城郭，汶水、徂徠如畫，而半山居霧若帶然。戊申晦，五鼓設燭，與子穎坐日觀亭，待日出。大風揚積雪擊面。亭東自雙石溪。頃之，雲霧自山谷中起，遮掩日光。極目四望，唯見群山起伏，白雪皚皚，氣勢雄渾。',
  },

  {
    id: 'classic-weixue',
    category: 'classic',
    dynasty: 'qing',
    title: '為學一首示子姪',
    source: '彭端淑',
    description: '彭端淑以蜀鄙二僧故事，勉人立志為學。',
    content: '天下事有難易乎？為之，則難者亦易矣；不為，則易者亦難矣。人之為學有難易乎？學之，則難者亦易矣；不學，則易者亦難矣。蜀之鄙有二僧：其一貧，其一富。貧者語於富者曰：「吾欲之南海，何如？」富者曰：「子何恃而往？」曰：「吾一瓶一缽足矣。」富者曰：「吾數年來欲買舟而下，猶未能也。子何恃而往！」越明年，貧者自南海還，以告富者。富者有慚色。西蜀之去南海，不知幾千里也，僧富者不能至而貧者至焉。人之立志，顧不如蜀鄙之僧哉？是故聰與敏，可恃而不可恃也；自恃其聰與敏而不學者，自敗者也。昏與庸，可限而不可限也；不自限其昏與庸而力學不倦者，自力者也。',
  },

  {
    id: 'classic-qing-liangqichao',
    category: 'classic',
    dynasty: 'qing',
    title: '少年中國說',
    source: '梁啟超',
    description: '梁啟超慷慨激昂之政論名篇，極具書法揮灑氣勢。',
    content: '故今日之責任，不在他人，而全在我少年。少年智則國智，少年富則國富；少年強則國強，少年獨立則國獨立；少年自由則國自由；少年進步則國進步；少年勝於歐洲，則國勝於歐洲；少年雄於地球，則國雄於地球。紅日初升，其道大光。河出伏流，一瀉汪洋。潛龍騰淵，鱗爪飛揚。乳虎嘯谷，百獸震惶。鷹隼試翼，風塵翕張。奇花初胎，矞矞皇皇。干將發硎，有作其芒。天戴其蒼，地履其黃。縱有千古，橫有八荒。前途似海，來日方長。美哉我少年中國，與天不老！壯哉我中國少年，與國無疆！',
  },

  {
    id: 'poem-qing-huangjingren',
    category: 'poem',
    dynasty: 'qing',
    title: '別老母',
    source: '黃景仁',
    description: '清代詩人黃景仁離家遠行前辭別老母的感人詩篇。',
    content: '防生憎別離苦，分襟尤恨此行遲。誰言寸草心，報得三春暉。',
  },

  {
    id: 'poem-qing-baiju',
    category: 'poem',
    dynasty: 'qing',
    title: '白芍藥',
    source: '袁枚',
    description: '袁枚寫白芍藥的清雅。',
    content: '昨夜月明花滿地，今朝花落月當空。可憐一樹白芍藥，不比尋常雜亂紅。',
  },

  {
    id: 'sutra-yinzhi-wen',
    category: 'sutra',
    dynasty: 'qing',
    title: '文昌帝君陰騭文',
    source: '清·善書經典',
    description: '勸善書，警示積陰德、行善積福、孝敬父母之儒道合一經典。',
    content: '帝君曰：吾一十七世為士大夫，身未嘗虐民酷吏；救人之難，濟人之急，憫人之孤，容人之過。廣行陰騭，上格蒼穹。人能如我存心，天必賜汝以福。於是訓於人曰：昔于公治獄，大興駟馬之門；竇氏濟人，高折五枝之桂。救蟻中狀元之選，埋蛇享宰相之榮。欲廣福田，須憑心地。行時時之方便，作種種之陰功。利物利人，修善修福。正直代天行化，慈祥為國救民。存平等心，說便利話。尊鏡賢哲，孝敬雙親。禮茂乾坤，誠招日月。印造經文，創修寺院。捨藥材以救疾苦，施茶水以解渴飢。點夜燈以照人行，造河船以渡人涉。或買物而放生，或持齋而戒殺。舉步常看蟲蟻，禁火莫燒山林。勿登山而網禽鳥，勿臨水而毒魚蝦。勿宰耕牛，勿棄字紙。勿謀人之財產，勿妒人之技能。勿淫人之妻女，勿唆人之爭訟。勿壞人之名節，勿破人之婚姻。勿因私讎，使人兄弟不和；勿因小利，使人父子不睦。勿倚權勢而侮善良，勿恃富豪而欺貧困。依本分而行，循天理而作。',
  },

  {
    id: 'sutra-zhuzi-geyan',
    category: 'sutra',
    dynasty: 'qing',
    title: '朱子治家格言',
    source: '清·朱柏廬',
    description: '儒家修身齊家經典，又稱《治家格言》，字字珠璣。',
    content: '黎明即起，灑掃庭除，要內外整潔；既昏便息，關鎖門戶，必親自檢點。一粥一飯，當思來處不易；半絲半縷，恆念物力維艱。宜未雨而綢繆，毋臨渴而掘井。自奉必須儉約，宴客切勿留連。器具質而潔，瓦缶勝金玉；飲食約而精，園蔬愈珍饈。勿營華屋，勿謀良田。三姑六婆，實淫盜之媒；婢美妾嬌，非閨房之福。奴僕勿用俊美，妻妾切忌艷妝。祖宗雖遠，祭祀不可不誠；子孫雖愚，經書不可不讀。居身務期質樸，教子要有義方。勿貪意外之財，勿飲過量之酒。與肩挑貿易，毋占便宜；見貧苦親鄰，須加溫恤。刻薄成家，理無久享；倫常乖舛，立見消亡。兄弟叔姪，須分多潤寡；長幼內外，宜法肅詞嚴。聽婦言，乖骨肉，豈是丈夫；重資財，薄父母，不成人子。娶媳求淑女，勿計妝堨；嫁女擇佳婿，毋索重聘。見富貴而生諂容者，最可恥；遇貧窮而作驕態者，賤莫甚。居家戒爭訟，訟則終凶；處世戒多言，言多必失。',
  },

  {
    id: 'sutra-guandi-juexi',
    category: 'sutra',
    dynasty: 'qing',
    title: '關聖帝君覺世真經 (全文)',
    source: '清·課誦經典',
    description: '關帝覺世真經，勸導世人敬天地、禮神明、孝雙親、重仁義，字字珠璣。',
    content: '帝君曰：人生於世，貴守本分。凡事依循理法，不可欺心。敬天地，禮神明，孝父母，愛兄弟。待人以寬，律己以嚴。毋貪非分之財，毋行不義之事。善惡昭彰，天理昭然。作善降之百祥，作惡降之百殃。吾本無私，唯佑善人。世人宜諦聽吾言，切莫自誤。己所不欲，勿施於人。行善之人，天必佑之；作惡之人，天必罰之。人若能改過遷善，神明亦必降福消災。宜勉力行之，勿忽。',
  },

  {
    id: 'sutra-bodhicitta-ex',
    category: 'sutra',
    dynasty: 'qing',
    title: '勸發菩提心文',
    source: '清·實賢 撰',
    description: '省庵大師大作，分析發心之八相與十種因緣，為修行淨土之重要指南。',
    content: '不肖、愚下凡夫僧實賢，泣血稽顙，哀告現前大眾，及當世淨信男女等，惟願慈悲，少加聽察。\n嘗聞入道要門，發心為首；修行急務，立願居先。願立，則眾生可度；心發，則佛道堪成。苟不發廣大心，立堅固願；則縱經塵劫，依然還在輪迴；雖有修行，總是徒勞辛苦。故華嚴經云：「忘失菩提心，修諸善法，是名魔業」。忘失尚爾，況未發乎？故知欲學如來乘，必先具發菩薩願，不可緩也。\n然心願差別，其相乃多；若不指陳，如何趨向？今為大眾略而言之。相有其八，所謂邪、正、真、偽、大、小、偏、圓是也。\n邪：世有行人，一向修行，不究自心，但知外務：或求利養，或好名聞，或貪現世欲樂，或望未來果報。如是發心，名之為「邪」。\n正：既不求利養名聞，又不貪欲樂果報；唯為生死，為菩提。如是發心，名之為「正」。\n真：念念上求佛道，心心下化眾生。聞佛道長遠，不生退怯；觀眾生難度，不生厭倦。如登萬仞之山，必窮其頂；如上九層之塔，必造其顛。如是發心，名之為「真」。\n偽：有罪不懺，有過不除，內濁外清，始勤終怠。雖有好心，多為名利之所夾雜；雖有善法，復為罪業之所染污。如是發心，名之為「偽」。\n大：眾生界盡，我願方盡；菩提道成，我願方成。如是發心，名之為「大」。\n小：觀三界如牢獄，視生死如怨家。但期自度，不欲度人。如是發心，名之為「小」。\n偏：若於心外，見有眾生，及以佛道，願度願成；功勛不忘，知見不泯。如是發心，名之為「偏」。\n圓：若知自性是眾生，故願度脫；自性是佛道，故願成就。不見一法，離心別有；以虛空之心，發虛空之願，行虛空之行，證虛空之果，亦無虛空之相可得。如是發心，名之為「圓」。\n知此八種差別，則知審察；知審察，則知去取；知去取，則可發心。云何審察？謂我所發心，於此八中，為邪、為正？為真、為偽？為大、為小？為偏、為圓？云何去取？所謂去邪、去偽、去小、去偏，取正、取真、取大、取圓。如此發心，方得名為真正發菩提心也。',
  },

  {
    id: 'poem-qing-lugang',
    category: 'poem',
    dynasty: 'qing',
    title: '鹿港乘桴記',
    source: '洪繻',
    description: '「台灣高中」學段必備台灣古典散文，洪繻感嘆鹿港廢港與人事無常，流露家國興亡之思。',
    content: '樓閣萬家，街衢對峙，有亭翼然。亙二、三里，直如弦、平如砥，暑行不汗身、雨行不濡履。一水通津，出海之涘，估帆葉葉，潮汐下上，去來如龍，貨舶相望；而店前可以驅車、店後可以繫榜者，昔之鹿港也。人煙猶是，而蕭條矣；邑里猶是，而泬寥矣。海天蒼蒼、海水茫茫，去之五里，涸為鹽場，萬瓦如甃、長隄如隍，無懋遷、無利涉；望之黯然可傷者，今之鹿港也。昔之盛，固余所不見；而其未至於斯之衰也，尚為余少時所目覩。蓋鹿港扼南北之中，其海口去閩南之泉州，僅隔一海峽而遙。閩南、浙、粵之貨，每由鹿港運輸而入，而臺北、臺南所需之貨，恆由鹿港輸出，乃至臺灣土產之輸於閩、粵者，亦靡不以鹿港為中樞。蓋藏既富，絃誦興焉，故黌序之士相望於道，而春秋試之貢於京師、注名仕籍者，歲有其人，非猶夫以學校聚奴隸者也。而是時鹿港通海之水已淺可涉矣，海艟之來，止泊於沖西內津，昔之所謂「鹿港飛帆」者，已不概見矣。綑載之往來，皆以竹筏運赴大艑矣。然是時之竹筏，猶千百數也；衣食於其中者，尚數百家也。迄於今版圖既易，海關之吏猛於虎豹，華貨之不來者有之矣。洎乎火車之路全通，外貨之來由南北而入，不復由鹿港而出矣；重以關稅之苛，關吏之酷，牟販之夫多至破家，而閩貨之不能由南北來者，亦復不敢由鹿港來也。鹽田之築，肇自近年。日本官吏固云欲以阜鹿民也，而其究竟，則實民間之輸巨貲以供官府之收厚利而已。且因是而阻水不行，山潦之來，鹿港人家半入洪浸，屋廬之日就頹毀，人民之日即離散，有由然矣。余往年攜友乘桴游於海濱，是時新鹽田未興築、舊鹽田猶未竣工；余亦無心至於隄下，臨海徘徊，海水浮天如笠，一白萬里如銀，滉漾碧綠如琉璃。夕陽欲下，月鉤初上；水鳥不飛，篙工撐棹。向新溝迤邐而行，則密邇鹿港之舊津，向時估帆所出入者，時已淤為沙灘，為居民鋤作菜圃矣。沿新溝而南至於大橋頭，則已挈鹿港之首尾而全觀之矣。望街尾一隅而至安平鎮，則割臺後之飛甍鱗次數百家燬於丙申兵火者，今猶瓦礫成邱，荒涼慘目也。猶幸市況凋零，為當道所不齒；不至於市區改正，破裂闤闠、驅逐人家以為通衢也。然而再經數年，則不可知之矣。滄桑時之可怖心，類如此也。游興已終，舍桴而步，遠近燈火明滅；屈指盛時所號萬家邑者，今裁三千家而已：可勝慨哉！',
  },
  {
    id: 'poem-qing-quanhelun',
    category: 'poem',
    dynasty: 'qing',
    title: '勸和論',
    source: '鄭用錫',
    description: '「台灣高中」學段必備台灣古典散文，鄭用錫借由勸戒分類械鬥，倡導族群和諧之名著。',
    content: '甚矣，人心之變也，自分類始！其禍倡於匪徒，後遂燎原莫遏，玉石俱焚。雖正人君子，亦受其牽制而或朋從之也。夫人與禽各為一類、邪與正各為一類，此不可不分。乃同此血氣、同此官骸、同為國家之良民、同為鄉閭之善人，無分士、無分民，即子夏所言「四海皆兄弟」是也，況當共處一隅？揆諸出入相友之義，古聖賢所謂同鄉共井者也。在字義，友從兩手、朋從兩肉。是朋友如一身左右手，即吾身之肉也。今試執塗人而語之曰：「爾其自戕爾手，爾其自噬爾肉！」鮮不拂然而怒！何今分類至於此極耶？顧分類之害，甚於臺灣。臺屬尤甚於淡之新、艋。臺為五方雜處，自林逆倡亂以來，有分為閩、粵焉，有分為漳、泉焉。閩、粵以其異省也，漳、泉以其異府也。然同自內府播遷而來，則同為臺人而已。今以異省、異府若分畛域，王法在所必誅。矧更同為一府，而亦有秦、越之異，是變本加厲，非奇而又奇者哉？夫人未有不親其所親，而能親其所疏。同居一府，猶同室之兄弟，至親也。乃以同室而操戈，更安能由親及疏，而親隔府之漳人、親隔省之粵人乎？淡屬素敦古處，新、艋尤為菁華所聚之區，遊斯土者，嘖嘖稱羨。自分類興，元氣剝削殆盡，未有如去年之甚也！干戈之禍愈烈，村市半成邱墟。問為漳、泉而至此乎？無有也。問為閩、粵而至此乎？無有也。蓋孽由自作，釁起鬩牆，大抵在非漳泉、非閩粵間耳。自來物窮必變，慘極知悔。天地有好生之德，人心無不轉之時。予生長是邦，自念士為四民之首，不能與在事諸公竭誠化導，力挽而更張之，滋愧實甚。願今以後，父誡其子、兄告其弟，各革面、各洗心，勿懷夙忿、勿蹈前愆。既親其所親、亦親其所疏，一體同仁，斯內患不生、外禍不至。漳、泉、閩、粵之氣習，默消於無形。譬如人身血脈節節相通，自無他病；數年以後，仍成樂土，豈不休哉！',
  },
  {
    id: 'poem-qing-qinyuanchunshunxifusheng',
    category: 'poem',
    dynasty: 'qing',
    title: '沁園春·瞬息浮生',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '丁巳重陽前三日，夢亡婦淡妝素服，執手硬嚥\n語多不復能\n但臨別有云：“銜恨願爲天上月，年年猶得向郎圓”\n婦素未工詩，不知何以得此也\n覺後感賦長調:\n瞬息浮生，薄命如斯，低徊怎忘？\n記繡榻閒時，並吹紅雨，雕闌曲處，同倚斜陽。\n夢好難留，詩殘莫續，贏得更深哭一場。\n遺容在，只靈飆一轉，未許端詳。\n重尋碧落茫茫，料短髮，朝來定有霜。\n便人間天上，塵緣未斷，春花秋葉，觸緒還傷。\n欲結綢繆，翻驚搖落，減盡荀衣昨日香。\n真無奈，倩聲聲鄰笛，譜出迴腸。',
  },
  {
    id: 'poem-qing-maozhai',
    category: 'poem',
    dynasty: 'qing',
    title: '茅齋',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '閒亭照白日，一室羅古今\n偶焉此棲遲，抱膝悠然吟\n吟罷有餘適，散矚復披襟\n時開玉懷卷，或彈珠柱琴\n檐樹吐新花，枝頭語珍禽\n花發饒冶色，禽鳴多姣音\n色冶眩春目，音姣傷春心\n夕陽下虞淵，寂莫還空林\n清光復相照，片月西山嶺\n東園桃李姿，是妾嫁君時\n燕婉爲夫婦，相愛不相離\n良人忽遠征，妾獨守空幃\n憂來恆自嘆，冀死魂追隨\n又念妾死時，誰制萬里衣\n幸有雙鯉魚，擬爲寄君辭\n終日不成章，含淚自封題\n君若得鯉魚，剖魚開素書\n但看行中字，一一與淚俱',
  },
  {
    id: 'poem-qing-jinlqujiangximingyanbiefucizengzhi',
    category: 'poem',
    dynasty: 'qing',
    title: '金縷曲·姜西溟言別賦此贈之',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '誰復留君住\n嘆人生、幾翻離合，便成遲暮\n最憶西窗同剪燭，卻話家山夜雨\n不道只、暫時相聚\n袞袞長江蕭蕭木，送遙天、白雁哀鳴去\n黃葉下，秋如許\n曰歸因甚添愁緒\n料強似、冷煙寒月，棲遲梵宇\n一事傷心君落魄，兩鬢飄蕭未遇\n有解憶、長安兒女\n裘敝入門空太息，信古來、才命真相負\n身世恨，共誰語？',
  },
  {
    id: 'poem-qing-jinlquwangfujiriyougan',
    category: 'poem',
    dynasty: 'qing',
    title: '金縷曲·亡婦忌日有感',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '此恨何時已\n滴空階、寒更雨歇，葬花天氣\n三載悠悠魂夢杳，是夢久應醒矣\n料也覺、人間無味\n不及夜臺塵土隔，冷清清、一片埋愁地\n釵鈿約，竟拋棄\n重泉若有雙魚寄\n好知他、年來苦樂，與誰相倚\n我自中宵成轉側，忍聽湘弦重理\n待結個、他生知己\n還怕兩人俱薄命，再緣慳、剩月零風裏\n清淚盡，紙灰起',
  },
  {
    id: 'poem-qing-jinlquweiximing',
    category: 'poem',
    dynasty: 'qing',
    title: '金縷曲·慰西溟',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '何事添悽咽\n但由他、天公簸弄，莫教磨涅\n失意每多如意少，終古幾人稱屈\n須知道、福因才折\n獨臥藜牀看北斗，背高城、玉笛吹成血\n聽譙鼓，二更徹\n丈夫未肯因人熱，且乘閒、五湖料理，扁舟一葉\n淚似秋霖揮不盡，灑向野田黃蝶\n須不羨、承明班列\n馬跡車塵忙未了，任西風吹冷長安月\n又蕭寺，花如雪',
  },
  {
    id: 'poem-qing-fengliuziqiujiaoshelie',
    category: 'poem',
    dynasty: 'qing',
    title: '風流子·秋郊射獵',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '平原草枯矣，重陽後，黃葉樹騷騷\n記玉勒青絲，落花時節，曾逢拾翠，忽聽吹簫\n今來是、燒痕殘碧盡，霜影亂紅凋\n秋水映空，寒煙如織，皁雕飛處，天慘雲高\n人生須行樂，君知否。容易兩鬢蕭蕭\n自與東君作別，剗地無聊\n算功名何許，此身博得\n短衣射虎，沽酒西郊。\n便向夕陽影裏，倚馬揮毫',
  },
  {
    id: 'poem-qing-gaolouwangyue',
    category: 'poem',
    dynasty: 'qing',
    title: '高樓望月',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '慼慼復慼慼，高樓月如雪\n二八正嬋娟，月明翡翠鈿\n由來工織錦，生小倚朱弦\n朱弦豈解愁，素手似雲浮\n一聲落天上，聞者皆淚流\n別郎已經年，望郎出樓前\n青天如海水，碧月如珠圓\n月圓以復缺，不見長安客\n古道白於霜，沙滅行人跡\n月出光在天，月高光在地\n何當同心人，兩兩不相棄',
  },
  {
    id: 'poem-qing-yuquanshieryun',
    category: 'poem',
    dynasty: 'qing',
    title: '玉泉十二韻',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '地湧西山脈，名標禁御泉\n百層飛作雨，萬頃匯成淵\n潤下終歸海，源高卻自天\n縈煙來樹杪，帶雪落雲邊\n隱見瑤光曳，琤蓯佩響傳\n紅棟橋宛轉，烏榜棹洄沿\n蛟龍蟠翠島，雁鶩起瓊田\n鏡面晶熒合，珠痕盪漾圓\n翠流初放荇，嬌擁半開蓮\n睿賞懸孤鑑，餘波溢九璇\n那居真有慶，魚藻在詩篇',
  },
  {
    id: 'poem-qing-pipaxianzhongqiu',
    category: 'poem',
    dynasty: 'qing',
    title: '琵琶仙·中秋',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '碧海年年，試問取、冰輪爲誰圓缺\n吹到一片秋香，清輝瞭如雪\n愁中看、好天良夜，知道盡成悲咽\n隻影而今，那堪重對，舊時明月\n花徑裏、戲捉迷藏，曾惹下蕭蕭井梧葉\n記否輕紈小扇，又幾番涼熱\n只落得，填膺百感，總茫茫、不關離別。\n一任紫玉無情，夜寒吹裂',
  },
  {
    id: 'poem-qing-baizilingsuhanercun',
    category: 'poem',
    dynasty: 'qing',
    title: '百字令·宿漢兒村',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '無情野火，趁西風燒遍、天涯芳草\n榆塞重來冰雪裏，冷入鬢絲吹老\n牧馬長嘶，徵笳亂動，併入愁懷抱\n定知今夕，庾郎瘦損多少\n便是腦滿腸肥，尚難消受，此荒煙落照\n何況文園憔悴後，非復酒壚風調\n回樂峯寒，受降城遠，夢向家山繞\n茫茫百感，憑高唯有清嘯',
  },
  {
    id: 'poem-qing-mantingfanghouxuefanya',
    category: 'poem',
    dynasty: 'qing',
    title: '滿庭芳·堠雪翻鴉',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '堠雪翻鴉，河冰躍馬，驚風吹度龍堆\n陰磷夜泣，此景總堪悲\n待向中宵起舞，無人處、那有村雞\n只應是，金笳暗拍，一樣淚沾衣\n須知今古事，棋枰勝負，翻覆如斯\n \n嘆紛紛蠻觸，回首成非\n剩得幾行青史，斜陽下、斷碣殘碑\n年華共，混同江水，流去幾時回',
  },
  {
    id: 'poem-qing-shuidiaogetoutixishanqiushuangtu',
    category: 'poem',
    dynasty: 'qing',
    title: '水調歌頭·題西山秋爽圖',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '空山梵唄靜，水月影俱沉\n悠然一境人外，都不許塵侵\n歲晚憶曾遊處，猶記半竿斜照，一抹界疏林\n絕頂茅庵裏，老衲正孤吟\n雲中錫，溪頭釣，澗邊琴\n此生著幾兩屐，誰識臥遊心?\n準擬乘風歸去，錯向槐安回首，何日得投簪\n布襪青鞋約，但向畫圖尋',
  },
  {
    id: 'poem-qing-jinrenpenglupanjingyesiguanlianyouhuaisunyou',
    category: 'poem',
    dynasty: 'qing',
    title: '金人捧露盤·淨業寺觀蓮有懷蓀友',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '藕風輕，蓮露冷，斷虹收，正紅窗、初上簾鉤\n田田翠蓋，趁斜陽魚浪香浮\n此時畫閣垂楊岸，睡起梳頭\n舊遊蹤，招提路，重到處，滿離憂\n想芙蓉湖上悠悠\n紅衣狼藉，臥看少妾蕩蘭舟\n午風吹斷江南夢，夢裏菱謳',
  },
  {
    id: 'poem-qing-fangshu',
    category: 'poem',
    dynasty: 'qing',
    title: '芳樹',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '連理無分影，同心豈獨芳\n傍檐巢翡翠，臨水宿鴛鴦\n葉葉含春思，枝枝向畫廊\n君情若比樹，妾意復何傷\n陌上誰攀折，閨中思復侵\n眼凝清露重，眉斂翠煙深\n羌笛臨風曲，悲笳出塞音\n縱垂千萬縷，那系別離心',
  },
  {
    id: 'poem-qing-huanxishajiaoyoulianju',
    category: 'poem',
    dynasty: 'qing',
    title: '浣溪沙·郊遊聯句',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '出郭尋春春已闌(陳維崧)，東風吹面不成寒(秦松齡)，青村幾曲到西山(嚴繩孫)\n並馬未須愁路遠(姜宸英)，看花且莫放杯閒(朱彝尊)，人生別易會常難(納蘭性德)',
  },
  {
    id: 'poem-qing-danhuangliuyongliu',
    category: 'poem',
    dynasty: 'qing',
    title: '淡黃柳·詠柳',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '三眠未歇，乍到秋時節\n一樹料陽蟬更咽，曾綰灞陵離別\n絮己爲萍風捲葉，空悽切\n長條莫輕折，蘇小恨，倩他說\n盡飄零、遊冶章臺客\n紅板橋空，湔裙人去，依舊曉風殘月',
  },
  {
    id: 'poem-qing-binyunsonglingzhenhanxiang',
    category: 'poem',
    dynasty: 'qing',
    title: '鬢雲松令·枕函香',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '枕函香，花徑漏\n依約相逢，絮語黃昏後\n時節薄寒人病酒，剗地梨花，徹夜東風瘦\n掩銀屏，垂翠袖\n何處吹簫，脈脈情微逗\n腸斷月明紅豆蔻，月似當時，人似當時否',
  },
  {
    id: 'poem-qing-nanloulingsaiwaichongjiu',
    category: 'poem',
    dynasty: 'qing',
    title: '南樓令·塞外重九',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '古木向人秋，驚蓬掠鬢稠\n是重陽、何處堪愁\n記得當年惆悵事，正風雨，下南樓\n斷夢幾能留，香魂一哭休\n怪涼蟬、空滿衾裯\n霜落烏啼渾不睡，偏想出，舊風流',
  },
  {
    id: 'poem-qing-hongchuangyueyanguihuaxie',
    category: 'poem',
    dynasty: 'qing',
    title: '紅窗月·燕歸花謝',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '燕歸花謝，早因循、又過清明\n是一般風景，兩樣心情\n猶記碧桃影裏、誓三生\n烏絲闌紙嬌紅篆，歷歷春星\n道休孤密約，鑑取深盟\n語罷一絲香露、溼銀屏\n ',
  },
  {
    id: 'poem-qing-linjiangxiansiyuruchenyunzhushui',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙·絲雨如塵雲著水',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '絲雨如塵雲著水，嫣香碎拾吳宮\n百花冷暖避東風\n酷憐嬌易散，燕子學偎紅\n人說病宜隨月減，懨懨卻與春同\n可能留蝶抱花叢\n不成雙夢影，翻笑杏梁空\n ',
  },
  {
    id: 'poem-qing-linjiangxianguyan',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙·孤雁',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '霜冷離鴻驚失伴，有人同病相憐\n擬憑尺素寄愁邊，愁多書屢易，雙淚落燈前\n莫對月明思往事，也知消減年年\n無端嘹唳一聲傳，西風吹隻影，剛是早秋天\n ',
  },
  {
    id: 'poem-qing-hujiamalanyuciguanwenquangongjishiyun',
    category: 'poem',
    dynasty: 'qing',
    title: '扈駕馬蘭峪賜觀溫泉恭紀十韻',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '御天來鳳輦，浴日啓龍池\n野迥紆皇覽，春濃值聖時\n落花縈彩仗，初柳拂朱旗\n行漏三辰擁，停鑾萬象隨\n瑞徵泉是醴，喜溢沼生芝\n特許觀靈液，相將涉禁墀',
  },
  {
    id: 'poem-qing-niguyushengweisanshi',
    category: 'poem',
    dynasty: 'qing',
    title: '擬古·予生未三十',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '予生未三十，憂愁居其半\n心事如落花，春風吹已斷\n行當適遠道，作記殊汗漫\n寒食青草多，薄暮煙冥冥\n山桃一夜紅，茵箔隨飄零\n願餐玉紅草，一醉不復醒',
  },
  {
    id: 'poem-qing-banjieyuyuange',
    category: 'poem',
    dynasty: 'qing',
    title: '班婕妤怨歌',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '團團望舒月，皓皓冰蠶絹\n欲卻炎天暑，比月裁成扇\n望舒圓易缺，金風換炎節\n風涼秋氣寒，匣扇復誰看\n扇棄何足道，感妾傷懷抱\n對月淚如絲，君恩異舊時',
  },
  {
    id: 'poem-qing-linjiangxianhanliu',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙·寒柳',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '飛絮飛花何處是，層冰積雪摧殘，疏疏一樹五更寒\n愛他明月好，憔悴也相關\n最是繁絲搖落後，轉教人憶春山\n湔裙夢斷續應難\n西風多少恨，吹不散眉彎',
  },
  {
    id: 'poem-qing-linjiangxianzuoyegerencengyouyue',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙·昨夜個人曾有約',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '昨夜個人曾有約，嚴城玉漏三更\n一鉤新月幾疏星\n夜闌猶未寢，人靜鼠窺燈\n原是瞿唐風間阻，錯教人恨無情\n小闌干外寂無聲\n幾回腸斷處，風動護花鈴',
  },
  {
    id: 'poem-qing-dielianhuayoudaolyangcengzhechu',
    category: 'poem',
    dynasty: 'qing',
    title: '蝶戀花·又到綠楊曾折處',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '又到綠楊曾折處，不語垂鞭，踏遍清秋路\n衰草連天無意緒，雁聲遠向蕭關去\n不恨天涯行役苦，只恨西風，吹夢成今古\n明日客程還幾許，沾衣況是新寒雨',
  },
  {
    id: 'poem-qing-dielianhuayandifengguangliubuzhu',
    category: 'poem',
    dynasty: 'qing',
    title: '蝶戀花·眼底風光留不住',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '眼底風光留不住，和暖和香，又上雕鞍去\n欲倩菸絲遮別路，垂楊那是相思樹\n惆悵玉顏成間阻，何事東風，不作繁華主\n斷帶依然留乞句，斑騅一系無尋處',
  },
  {
    id: 'poem-qing-tashaxingyiliutijian',
    category: 'poem',
    dynasty: 'qing',
    title: '踏莎行·倚柳題箋',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '倚柳題箋，當花側帽，賞心應比驅馳好\n錯教雙鬢受東風，看吹綠影成絲早\n金殿寒鴉，玉階春草，就中冷暖和誰道\n小樓明月鎮長閒，人生何事緇塵老\n ',
  },
  {
    id: 'poem-qing-dielianhuaxinkuzuiliantianshangyue',
    category: 'poem',
    dynasty: 'qing',
    title: '蝶戀花·辛苦最憐天上月',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '辛苦最憐天上月，一夕如環，夕夕都成玦\n若似月輪終皎潔，不辭冰雪爲卿熱\n無那塵緣容易絕，燕子依然，軟踏簾鉤說\n唱罷秋墳愁未歇，春叢認取雙棲蝶',
  },
  {
    id: 'poem-qing-hechuanchunqian',
    category: 'poem',
    dynasty: 'qing',
    title: '河傳·春淺',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '春淺，紅怨，掩雙環\n微雨花間，晝閒\n無言暗將紅淚彈\n闌珊，香銷輕夢還\n斜倚畫屏思往事，皆不是，空作相思字\n記當時垂柳絲，花枝，滿庭蝴蝶兒',
  },
  {
    id: 'poem-qing-nanxiangziyannuanyuchushou',
    category: 'poem',
    dynasty: 'qing',
    title: '南鄉子·煙暖雨初收',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '煙暖雨初收，落盡繁花小院幽\n摘得一雙紅豆子，低頭，說著分攜淚暗流\n人去似春休，卮酒曾將酹石尤\n別自有人桃葉渡，扁舟，一種煙波各自愁\n ',
  },
  {
    id: 'poem-qing-linjiangxiandiandibajiaoxinyusui',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙·點滴芭蕉心欲碎',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '點滴芭蕉心欲碎，聲聲催憶當初\n欲眠還展舊時書\n鴛鴦小字，猶記手生疏\n倦眼乍低緗帙亂，重看一半模糊\n幽窗冷雨一燈孤\n料應情盡，還道有情無',
  },
  {
    id: 'poem-qing-huanxishashuidaopiaolingbukelian',
    category: 'poem',
    dynasty: 'qing',
    title: '浣溪沙·誰道飄零不可憐',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '西郊馮氏園看海棠，因憶《香嚴詞》有感\n誰道飄零不可憐，舊遊時節好花天\n斷腸人去自經年\n一片暈紅才著雨，幾絲柔綠乍和煙\n倩魂銷盡夕陽前',
  },
  {
    id: 'poem-qing-langtaoshahongyingshiyouchuang',
    category: 'poem',
    dynasty: 'qing',
    title: '浪淘沙·紅影溼幽窗',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '紅影溼幽窗，瘦盡春光\n雨餘花外卻斜陽\n誰見薄衫低髻子，抱膝思量\n莫道不淒涼，早近持觴\n暗思何事斷人腸\n曾是向他春夢裏，瞥遇迴廊\n ',
  },
  {
    id: 'poem-qing-yumeirencandengfengmieluyanleng',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·殘燈風滅爐煙冷',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '殘燈風滅爐煙冷，相伴唯孤影\n判教狼藉醉清樽，爲問世間醒眼是何人\n難逢易散花間酒，飲罷空搔首\n閒愁總付醉來眠，只恐醒時依舊到樽前\n ',
  },
  {
    id: 'poem-qing-zhegutianyantiehanyuncidifei',
    category: 'poem',
    dynasty: 'qing',
    title: '鷓鴣天·雁貼寒雲次第飛',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '雁帖寒雲次第飛，向南猶自怨歸遲\n誰能瘦馬關山道，又到西風撲鬢時\n人杳杳，思依依，更無芳樹有烏啼\n憑將掃黛窗前月，持向今宵照別離\n ',
  },
  {
    id: 'poem-qing-wuzhonghaodubeicanyangshangxiaolou',
    category: 'poem',
    dynasty: 'qing',
    title: '於中好·獨背殘陽上小樓',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '獨背殘陽上小樓，誰家玉笛韻偏幽\n一行白雁遙天暮，幾點黃花滿地秋\n驚節序，嘆沉浮，穠華如夢水東流\n人間所事堪惆悵，莫向橫塘問舊遊\n ',
  },
  {
    id: 'poem-qing-zhegutianbiexurusimengbucheng',
    category: 'poem',
    dynasty: 'qing',
    title: '鷓鴣天·別緒如絲夢不成',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '別緒如絲夢不成，那堪孤枕夢邊城\n因聽紫塞三更雨，卻憶紅樓半夜燈\n書鄭重，恨分明，天將愁味釀多情\n起來呵手封題處，偏到鴛鴦兩字冰\n ',
  },
  {
    id: 'poem-qing-wuzhonghaoshiyuechusiyefengyuqimingrishiwangfushengchen',
    category: 'poem',
    dynasty: 'qing',
    title: '於中好·十月初四夜風雨其明日是亡婦生辰',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '塵滿疏簾素帶飄，真成暗度可憐宵\n幾回偷拭青衫淚，忽傍犀奩見翠翹\n惟有恨，轉無聊\n五更依舊落花朝\n衰楊葉盡絲難盡，冷雨悽風打畫橋\n ',
  },
  {
    id: 'poem-qing-wuzhonghaoxiaogouyuanlinjibuhua',
    category: 'poem',
    dynasty: 'qing',
    title: '於中好·小構園林寂不譁',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '小構園林寂不譁，疏籬曲徑仿山家\n晝長吟罷風流子，忽聽楸枰響碧紗\n添竹石，伴煙霞\n擬憑樽酒慰年華\n休嗟髀裏今生肉，努力春來自種花\n ',
  },
  {
    id: 'poem-qing-nanxiangziweiwangfutizhao',
    category: 'poem',
    dynasty: 'qing',
    title: '南鄉子·爲亡婦題照',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '淚咽卻無聲\n只向從前悔薄情，憑仗丹青重省識\n盈盈\n一片傷心畫不成\n別語忒分明\n午夜鶼鶼夢早醒\n卿自早醒儂自夢，更更\n泣盡風檐夜雨鈴',
  },
  {
    id: 'poem-qing-mingyuezhaoguzhouhaidian',
    category: 'poem',
    dynasty: 'qing',
    title: '明月棹孤舟·海淀',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '一片亭亭空凝佇\n趁西風霓裳偏舞\n白鳥驚飛，菰蒲葉亂，斷續浣紗人語\n丹碧駁殘秋夜雨\n風吹去採菱越女\n轆轤聲斷，昏鴉欲起，多少博山情緒',
  },
  {
    id: 'poem-qing-linjiangxiansiyuruchenyunzheshui',
    category: 'poem',
    dynasty: 'qing',
    title: '臨江仙 絲雨如塵雲着水',
    source: '納蘭性德',
    description: '清代經典詩歌，作者為納蘭性德。',
    content: '絲雨如塵雲着水，嫣香碎拾吳宮百花冷暖避東風酷憐嬌易散，燕子學偎紅人說病宜隨月減，懨懨卻與春同可能留蝶抱花叢不成雙夢影，翻笑杏梁空',
  },
  {
    id: 'poem-qing-mulanhualingnigujuejueci',
    category: 'poem',
    dynasty: 'qing',
    title: '木蘭花令·擬古決絕詞',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '人生若只如初見，何事秋風悲畫扇\n等閒變卻故人心，卻道故心人易變\n驪山語罷清宵半，淚雨霖鈴終不怨\n何如薄倖錦衣郎，比翼連枝當日願',
  },
  {
    id: 'poem-qing-zhegutianbeiliyingyingguzuoxiu',
    category: 'poem',
    dynasty: 'qing',
    title: '鷓鴣天·背立盈盈故作羞',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '背立盈盈故作羞，手挼梅蕊打肩頭\n欲將離恨尋郎說，待得郎來恨卻休\n雲淡淡，水悠悠\n一聲橫笛鎖空樓\n何時共泛春溪月，斷岸垂楊一葉舟',
  },
  {
    id: 'poem-qing-langtaoshayeyuzuochengqiu',
    category: 'poem',
    dynasty: 'qing',
    title: '浪淘沙·夜雨做成秋',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '夜雨做成秋，恰上心頭\n教他珍重護風流\n端的爲誰添病也，更爲誰羞\n密意未曾休，密願難酬\n珠簾四卷月當樓\n暗憶歡期真似夢，夢也須留',
  },
  {
    id: 'poem-qing-langtaoshawanghai',
    category: 'poem',
    dynasty: 'qing',
    title: '浪淘沙·望海',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '蜃闕半模糊，踏浪驚呼\n任將蠡測笑江湖\n沐日光華還浴月，我欲乘桴\n釣得六鰲無\n竿拂珊瑚\n桑田清淺問麻姑\n水氣浮天天接水，那是蓬壺',
  },
  {
    id: 'poem-qing-wuzhonghaoshuidaoyinshanxinglunan',
    category: 'poem',
    dynasty: 'qing',
    title: '於中好·誰道陰山行路難',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '誰道陰山行路難\n風毛雨血萬人歡\n松梢露點沾鷹紲，蘆葉溪深沒馬鞍\n依樹歇，映林看\n黃羊高宴簇金盤\n蕭蕭一夕霜風緊，卻擁貂裘怨早寒',
  },
  {
    id: 'poem-qing-yumeirenyinchuangxiliqingwulao',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·銀牀淅瀝青梧老',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '銀牀淅瀝青梧老，屧粉秋蛩掃\n採香行處蹙連錢，拾得翠翹何恨不能言\n迴廊一寸相思地，落月成孤倚\n背燈和月就花陰，已是十年蹤跡十年心',
  },
  {
    id: 'poem-qing-yijiangnansushuanglinshanyuanyougan',
    category: 'poem',
    dynasty: 'qing',
    title: '憶江南·宿雙林禪院有感',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '心灰盡、有發未全僧\n風雨消磨生死別，似曾相識只孤檠，情在不能醒\n搖落後，清吹那堪聽\n淅瀝暗飄金井葉，乍聞風定又鐘聲，薄福薦傾城',
  },
  {
    id: 'poem-qing-yiluosuoguojinyaoshanruhua',
    category: 'poem',
    dynasty: 'qing',
    title: '一絡索·過盡遙山如畫',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '過盡遙山如畫\n 短衣匹馬\n 蕭蕭落木不勝秋， 莫回首、 斜陽下\n別是柔腸縈掛\n 待歸才罷\n 卻愁擁髻向燈前， 說不盡、 離人話',
  },
  {
    id: 'poem-qing-yumeirenqulanshenchuzhongxiangjian',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·曲闌深處重相見',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '曲闌深處重相見，勻淚偎人顫\n淒涼別後兩應同，最是不勝清怨月明中\n半生已分孤眠過，山枕檀痕涴\n憶來何事最銷魂，第一折枝花樣畫羅裙',
  },
  {
    id: 'poem-qing-yumeirenchunqingzhidaolihuabao',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·春情只到梨花薄',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '春情只到梨花薄，片片催零落\n夕陽何事近黃昏，不道人間猶有未招魂\n銀箋別夢當時句，密綰同心苣\n爲伊判作夢中人，索向畫圖清夜喚真真',
  },
  {
    id: 'poem-qing-yumeirenhuanghunyoutingchengtoujiao',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·黃昏又聽城頭角',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '黃昏又聽城頭角，病起心情惡\n藥爐初沸短檠青，無那殘香半縷惱多情\n多情自古原多病，清鏡憐清影\n一聲彈指淚如絲，央及東風休遣玉人知',
  },
  {
    id: 'poem-qing-yumeirenqiuxixinbu',
    category: 'poem',
    dynasty: 'qing',
    title: '虞美人·秋夕信步',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '愁痕滿地無人省，露溼琅玕影\n閒階小立倍荒涼\n還剩舊時月色在瀟湘\n薄情轉是多情累，曲曲柔腸碎\n紅箋向壁字模糊，憶共燈前呵手爲伊書',
  },
  {
    id: 'poem-qing-wuzhonghaoyongshi',
    category: 'poem',
    dynasty: 'qing',
    title: '於中好·詠史',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '馬上吟成促渡江，分明閒氣屬閨房\n生憎久閉金鋪暗，花冷迴心玉一牀\n添哽咽，足淒涼\n誰教生得滿身香\n只今西海年年月，猶爲蕭家照斷腸',
  },
  {
    id: 'poem-qing-jingyesi',
    category: 'poem',
    dynasty: 'qing',
    title: '淨業寺',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '紅樓高聳碧池深，荷芰生涼豁遠襟\n湖色靜涵孤剎影，花香暗入定僧心\n經翻佛藏研朱莢，地賜朝家布紫金\n下馬長堤一吟望，梵鍾雜送海潮音',
  },
  {
    id: 'poem-qing-hubibazhou',
    category: 'poem',
    dynasty: 'qing',
    title: '扈蹕霸州',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '霸山重鎮奠神京，鸞輅春遊淑景明\n萬呱銀濤衝古岸，四圍玉甃護嚴城\n花乘暖日迎來騎，柳帶新膏綰去旌\n八寨雄圖今更固，行隨賞樂勝蓬瀛',
  },
  {
    id: 'poem-qing-liutiaobian',
    category: 'poem',
    dynasty: 'qing',
    title: '柳條邊',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '是處垣籬防絕塞，角端西來畫疆界\n漢使今行虎落中，秦城合築龍荒外\n龍荒虎落兩依然，護得當時飲馬泉\n若使春風知別苦，不應吹到柳條邊',
  },
  {
    id: 'poem-qing-gubeikou',
    category: 'poem',
    dynasty: 'qing',
    title: '古北口',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '亂山入戟擁孤城，一線人爭鳥道行\n地險東西分障塞，雲開南北望神京\n新圖已入三關志，往事休論十路兵\n都護近來長不調，年年烽火報生平',
  },
  {
    id: 'poem-qing-tangquanyingzhiliulongchuzhuyulantian',
    category: 'poem',
    dynasty: 'qing',
    title: '湯泉應制·六龍初駐浴藍天',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '六龍初駐浴藍天，碧瓦朱旗共一川\n潤逼仙桃紅自舞，醉酣人柳綠猶眠\n吹成暖律回燕谷，散作薰風入舜弦\n最是垂衣深聖德，不須詞筆頌甘泉',
  },
  {
    id: 'poem-qing-tangquanyingzhiqingshililecuichaoduan',
    category: 'poem',
    dynasty: 'qing',
    title: '湯泉應制·清時禮樂萃朝端',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '清時禮樂萃朝端，次第郊原引玉鑾\n河嶽千年歸帶礫，寢園三月拜衣冠\n便從畿甸親民隱，更啓神泉示從官\n非獨炎靈鍾坎德，恩波深處不知寒',
  },
  {
    id: 'poem-qing-tangquanyingzhiyulinyanchijingzhongkai',
    category: 'poem',
    dynasty: 'qing',
    title: '湯泉應制·魚鱗雁齒鏡中開',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '魚鱗雁齒鏡中開，濺沫爲霖遍九垓\n不用劫灰求彷彿，便從天漢象昭回\n桑壇法駕乘春轉，鶴禁仙鑣問寢來\n遙祝海隅同帝澤，年年長聽屬車雷',
  },
  {
    id: 'poem-qing-hujiaxishan',
    category: 'poem',
    dynasty: 'qing',
    title: '扈駕西山',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '鳳翥龍蟠勢作環，浮青不斷太行山\n九重殿閣蔥蘢裏，一氣風雲吐納間\n熊虎自當馳道伏，蛟螭長棒御書閒\n黃圖此日論形勝，慚愧頻叨侍從班',
  },
  {
    id: 'poem-qing-xingjingpeijifuling',
    category: 'poem',
    dynasty: 'qing',
    title: '興京陪祭福陵',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '龍盤鳳翥氣佳哉，東指齋宮玉輦來\n影入松楸仙仗遠，香升俎豆曉雲開\n盛儀備處千官肅，神貺乘時萬馬回\n豹尾叨陪須獻頌，小臣慚愧展微才',
  },
  {
    id: 'poem-qing-tangquanyingzhishenxiangxianchibangmoguang',
    category: 'poem',
    dynasty: 'qing',
    title: '湯泉應制·身向咸池榜末光',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '身向咸池榜末光，三危露暖不成霜\n金鋪照日初涵影，玉求生煙別作香\n地接蓬萊通御氣，波翻豆蔻散朝涼\n微臣幸屬賡歌日，願借如川獻壽觴',
  },
  {
    id: 'poem-qing-nidongrijingzhongshanyingzhitiaoyaotiefengsuolingong',
    category: 'poem',
    dynasty: 'qing',
    title: '擬冬日景忠山應制·岧嶢鐵鳳鎖琳宮',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '岧嶢鐵鳳鎖琳宮，親侍鑾輿度碧空\n聖主豈因崇象教，宸遊直自接鴻蒙\n遠山雪有一峯白，別浦楓餘幾樹紅\n天意不教常肅殺，佇看宇宙遍春風',
  },
  {
    id: 'poem-qing-nidongrijingzhongshanyingzhixiongguanzusedailingao',
    category: 'poem',
    dynasty: 'qing',
    title: '擬冬日景忠山應制·雄關阻塞戴靈鰲',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '雄關阻塞戴靈鰲，控制盧龍勝百牢\n山界萬重橫翠黛，海當三面湧銀濤\n哀笳帶月傳聲切，早雁迎秋度影高\n舊是六師開險處，待陪巡幸扈星旌',
  },
  {
    id: 'poem-qing-nanhaizixiangfengweidongjiumenkai',
    category: 'poem',
    dynasty: 'qing',
    title: '南海子·相風微動九門開',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '相風微動九門開，南陌離宮萬柳栽\n草色橫粘下馬泊，水光平佔晾鷹臺\n錦韉欲射波間去，玉輦疑從島上回\n自是軟紅驚十丈，天教到此洗塵埃',
  },
  {
    id: 'poem-qing-zhongyuanqianyixizhenshangoucheng',
    category: 'poem',
    dynasty: 'qing',
    title: '中元前一夕枕上偶成',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '酒醒池塘耿不眠，帳紋漠漠隔輕煙\n溪風到竹初疑雨，秋月如弓漸滿弦\n殘夢遠經吹角戍，明河長亙衣天\n哀蛩餞曉渾多事，也似嚴更古驛邊',
  },
  {
    id: 'poem-qing-nangezigushu',
    category: 'poem',
    dynasty: 'qing',
    title: '南歌子·古戍',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '古戍飢烏集，荒城野雉飛\n何年劫火剩殘灰，試看英雄碧血，滿龍堆\n玉帳空分壘，金笳已罷吹\n東風回首盡成非，不道興亡命也，豈人爲',
  },
  {
    id: 'poem-qing-taichangyinzitixiaozhao',
    category: 'poem',
    dynasty: 'qing',
    title: ' 太常引·自題小照 ',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '西風乍起峭寒生，驚雁避移營\n千里暮雲平，休回首、長亭短亭\n無窮山色，無邊往事，一例冷清清\n試倩玉蕭聲，喚千古、英雄夢醒',
  },
  {
    id: 'poem-qing-heyebeizhijiyirenshuishi',
    category: 'poem',
    dynasty: 'qing',
    title: '荷葉杯·知己一人誰是',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '知己一人誰是\n已矣\n贏得誤他生\n有情終古似無情，別語悔分明\n莫道芳時易度，朝暮\n珍重好花天\n爲伊指點再來緣，疏雨洗遺鈿',
  },
  {
    id: 'poem-qing-nigugaoyunmeichunri',
    category: 'poem',
    dynasty: 'qing',
    title: '擬古·高雲媚春日',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '高雲媚春日，坐覺魚鳥親\n可憐暮春候，病中別故人\n鶯啼花亂落，風吹成錦茵\n君去一何速，到家垂柳新\n芙蓉湖上月，照君垂長綸',
  },
  {
    id: 'poem-qing-nigumeirenlincanyue',
    category: 'poem',
    dynasty: 'qing',
    title: '擬古·美人臨殘月',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '美人臨殘月，無言若有思\n含顰但斜睇，吁嗟憐者誰\n予本多情人，寸心聊自持\n浩歌幽蘭曲，援琴終不怡\n私恨託遠夢，初日照簾幃',
  },
  {
    id: 'poem-qing-qingshanshidaowang',
    category: 'poem',
    dynasty: 'qing',
    title: '青衫溼·悼亡',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '近來無限傷心事，誰與話長更\n從教分付，綠窗紅淚，早雁初鶯\n當時領略，而今斷送，總負多情\n忽疑君到，漆燈風颭，癡數春星',
  },
  {
    id: 'poem-qing-yiqinechunshenqian',
    category: 'poem',
    dynasty: 'qing',
    title: '憶秦娥·春深淺',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '春深淺，一痕搖漾青如剪\n青如剪\n鷺鷥立處，煙蕪平遠\n吹開吹謝東風倦，緗桃自惜紅顏變\n紅顏變\n兔葵燕麥，重來相見\n ',
  },
  {
    id: 'poem-qing-yanermeiyongmei',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·詠梅',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '莫把瓊花比澹妝，誰似白霓裳\n別樣清幽，自然標格，莫近東牆\n冰肌玉骨天分付，兼付與淒涼\n可憐遙夜，冷煙和月，疏影橫窗',
  },
  {
    id: 'poem-qing-yanermeizhongjianxingebihaicha',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·重見星娥碧海槎',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '重見星娥碧海槎，忍笑卻盤鴉\n尋常多少，月明風細，今夜偏佳\n休籠彩筆閒書字，街鼓巳三撾\n菸絲欲嫋，露光微泫，春在桃花',
  },
  {
    id: 'poem-qing-yanermeiduyichunhanyanxifei',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·獨倚春寒掩夕扉',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '獨倚春寒掩夕扉，清露泣銖衣\n玉蕭吹夢，金釵劃影，悔不同攜\n刻殘紅燭曾相待，舊事總依稀\n料應遺恨，月中教去，花底催歸',
  },
  {
    id: 'poem-qing-yanermeilinxiaguifangshihanchou',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·林下閨房世罕儔',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '林下閨房世罕儔，偕隱足風流\n今來忍見，鶴孤華表，人遠羅浮\n中年定不禁哀樂，其奈憶曾遊\n浣花微雨，採菱斜日，欲去還留',
  },
  {
    id: 'poem-qing-luohuashixiyangshuihuanxialouti',
    category: 'poem',
    dynasty: 'qing',
    title: ' 落花時·夕陽誰喚下樓梯 ',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '夕陽誰喚下樓梯，一握香荑\n回頭忍笑階前立，總無語，也依依\n箋書直恁無憑據，休說相思\n勸伊好向紅窗醉，須莫及，落花時',
  },
  {
    id: 'poem-qing-yanermeiyonghongguniang',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·詠紅姑娘',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '騷屑西風弄晚寒，翠袖倚闌干\n霞綃裹處，櫻脣微綻，靺鞨紅殷\n故宮事往憑誰問，無恙是朱顏\n玉墀爭採，玉釵爭插，至正年間',
  },
  {
    id: 'poem-qing-tanpohuanxishafengxupiaocanyihuaping',
    category: 'poem',
    dynasty: 'qing',
    title: '攤破浣溪沙·風絮飄殘已化萍',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '風絮飄殘已化萍，泥蓮剛倩藕絲縈\n珍重別拈香一瓣，記前生\n人到情多情轉薄，而今真個悔多情\n又到斷腸回首處，淚偷零\n ',
  },
  {
    id: 'poem-qing-yanermeizhongyuanyeyougan',
    category: 'poem',
    dynasty: 'qing',
    title: '眼兒媚·中元夜有感',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '手寫香臺金字經，惟願結來生\n蓮花漏轉，楊枝露滴，想鑑微誠\n欲知奉倩神傷極，憑訴與秋擎\n西風不管，一池萍水，幾點荷燈',
  },
  {
    id: 'poem-qing-chaozhongcuoshuxianqinzhubuguanqing',
    category: 'poem',
    dynasty: 'qing',
    title: '朝中措·蜀弦秦柱不關情',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '蜀弦秦柱不關情，盡日掩雲屏\n己惜輕翎退粉，更嫌弱絮爲萍\n東風多事，餘寒吹散，烘暖微酲\n看盡一簾紅雨，爲誰親系花鈴',
  },
  {
    id: 'poem-qing-hedushenliangyuezhuandiaolan',
    category: 'poem',
    dynasty: 'qing',
    title: ' 河瀆神·涼月轉雕闌 ',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '涼月轉雕闌，蕭蕭木葉聲乾\n銀燈飄落瑣窗閒，枕屏幾疊秋山\n朔風吹透青縑被，藥爐火暖初沸\n清漏沉沉無寐，爲伊判得憔悴',
  },
  {
    id: 'poem-qing-yiqinechangpiaobo',
    category: 'poem',
    dynasty: 'qing',
    title: '憶秦娥·長飄泊',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '長飄泊，多愁多病心情惡\n心情惡\n模糊一片，強分哀樂\n擬將歡笑排離索，鏡中無奈顏非昨\n顏非昨\n才華尚淺，因何福薄',
  },
  {
    id: 'poem-qing-tanpohuanxishazangminghua',
    category: 'poem',
    dynasty: 'qing',
    title: '攤破浣溪沙·葬名花',
    source: '納蘭性德',
    description: '清代納蘭性德詞作名篇，詞風清麗婉約。',
    content: '林下荒苔道韞家，生憐玉骨委塵沙\n愁向風前無處說，數歸鴉\n半世浮萍隨逝水，一宵冷雨葬名花\n魂是柳綿吹欲碎，繞天涯',
  },
]
